import styled from 'styled-components'
import theme from '@app/ui/theme'

export const OuterContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 0 0 4px;
`

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const Divider = styled.div`
  height: 1px;
  background: ${theme.colors.light};
  margin: 6px 0;
`

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 2px 2px;
  font-size: 13px;
`

export const Label = styled.span`
  color: ${theme.colors.secondary};
  font-weight: 400;
  font-size: 12px;
  white-space: nowrap;
  margin-right: 12px;
`

export const Value = styled.span`
  font-weight: 600;
  font-size: 13px;
  color: ${theme.colors.primary};
  text-align: right;
  user-select: text !important;
  word-break: break-all;
`

export const CopyButton = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  padding: 2px 6px;
  border-radius: 4px;
  transition: background 0.15s;

  &:hover {
    background: ${theme.colors.light};
  }

  &:active {
    opacity: 0.7;
  }
`

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  text-align: left;
  width: 100%;
  padding: 0 12px;
  gap: 2px;
`

export const ClubName = styled.span`
  font-family: 'Inter', sans-serif;
  font-weight: 800;
  font-size: 15px;
  color: ${theme.colors.primary};
`

export const CourseName = styled.span`
  font-size: 13px;
  color: ${theme.colors.secondary};
`

export const DropdownTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  gap: 1px;
`

export const DropdownTitleClub = styled.span`
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
  opacity: 0.7;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  text-align: center;

  @media (max-width: 820px) {
    display: none;
  }
`

export const DropdownTitleCourse = styled.span`
  font-size: 13px;
  font-weight: 500;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 180px;
  text-align: center;
`
